import {
  ALL_FACILITIES,
  useSelectedFacilityId
} from '@/hooks/useFacilitiesQuery';
import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

import {
  ScreenerSettingName,
  useScreenerSettingsQuery
} from './useScreenerSettingsQuery';

export function useIsReferralOutboundEnabled(): boolean {
  const selectedFacilityId = useSelectedFacilityId();
  const facilityId =
    typeof selectedFacilityId === 'string' &&
    selectedFacilityId !== ALL_FACILITIES
      ? selectedFacilityId
      : undefined;

  const { data } = useScreenerSettingsQuery().useFindOneByFacilityId(
    {
      facilityId: facilityId ?? '',
      settingName: ScreenerSettingName.ReferralOutbound
    },
    {
      enabled: Boolean(facilityId)
    }
  );

  if (!FeatureFlagService.isEnabled(ExacareFeature.CRM_REFERRAL_OUTBOUND)) {
    return false;
  }

  if (!facilityId) {
    return false;
  }

  return data?.data?.value === 'enabled';
}
